import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Api } from '../Http';
export var DefaultViewDataProvider = /*#__PURE__*/function () {
  // TODO: pull Api from Http.ts to here

  function DefaultViewDataProvider() {
    var xBffCsrf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    _classCallCheck(this, DefaultViewDataProvider);
    _defineProperty(this, "_xBffCsrf", void 0);
    this._xBffCsrf = xBffCsrf;
  }
  return _createClass(DefaultViewDataProvider, [{
    key: "queryViewsAsync",
    value: function () {
      var _queryViewsAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(containerRID) {
        var _response$items;
        var metadataApiParameters,
          response,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              metadataApiParameters = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
              _context.next = 3;
              return Api.Views.queryViews({
                containerRID: containerRID,
                xBffCsrf: this._xBffCsrf.toString(),
                metadata: metadataApiParameters
              });
            case 3:
              response = _context.sent;
              return _context.abrupt("return", (_response$items = response.items) !== null && _response$items !== void 0 ? _response$items : []);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function queryViewsAsync(_x) {
        return _queryViewsAsync.apply(this, arguments);
      }
      return queryViewsAsync;
    }()
  }, {
    key: "getViewAsync",
    value: function () {
      var _getViewAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(viewRID) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Api.Views.getView({
                encodedViewRID: viewRID,
                xBffCsrf: this._xBffCsrf.toString()
              });
            case 2:
              return _context2.abrupt("return", _context2.sent);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getViewAsync(_x2) {
        return _getViewAsync.apply(this, arguments);
      }
      return getViewAsync;
    }()
  }, {
    key: "getViewByIdAsync",
    value: function () {
      var _getViewByIdAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(containerRID, viewId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Api.Views.getViewById({
                encodedContainerRID: containerRID,
                encodedViewId: viewId,
                xBffCsrf: this._xBffCsrf.toString()
              });
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getViewByIdAsync(_x3, _x4) {
        return _getViewByIdAsync.apply(this, arguments);
      }
      return getViewByIdAsync;
    }()
  }, {
    key: "createBlock",
    value: function () {
      var _createBlock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(createBlockRequest) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return Api.Blocks.createBlock(_objectSpread(_objectSpread({}, createBlockRequest), {}, {
                xBffCsrf: this._xBffCsrf.toString()
              }));
            case 2:
              return _context4.abrupt("return", _context4.sent);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createBlock(_x5) {
        return _createBlock.apply(this, arguments);
      }
      return createBlock;
    }()
  }, {
    key: "replaceBlockParameters",
    value: function () {
      var _replaceBlockParameters = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(replaceBlockParametersRequest) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return Api.Blocks.replaceBlockParameters(_objectSpread(_objectSpread({}, replaceBlockParametersRequest), {}, {
                xBffCsrf: this._xBffCsrf.toString()
              }));
            case 2:
              return _context5.abrupt("return", _context5.sent);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function replaceBlockParameters(_x6) {
        return _replaceBlockParameters.apply(this, arguments);
      }
      return replaceBlockParameters;
    }()
  }, {
    key: "deleteBlock",
    value: function () {
      var _deleteBlock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(deleteBlockRequest) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return Api.Blocks.deleteBlock(_objectSpread(_objectSpread({}, deleteBlockRequest), {}, {
                xBffCsrf: this._xBffCsrf.toString()
              }));
            case 2:
              return _context6.abrupt("return", _context6.sent);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function deleteBlock(_x7) {
        return _deleteBlock.apply(this, arguments);
      }
      return deleteBlock;
    }()
  }, {
    key: "createZone",
    value: function () {
      var _createZone = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(createZoneRequest) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return Api.Zones.createZone(_objectSpread(_objectSpread({}, createZoneRequest), {}, {
                xBffCsrf: this._xBffCsrf.toString()
              }));
            case 2:
              return _context7.abrupt("return", _context7.sent);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function createZone(_x8) {
        return _createZone.apply(this, arguments);
      }
      return createZone;
    }()
  }, {
    key: "replaceZoneParameters",
    value: function () {
      var _replaceZoneParameters = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(replaceZoneParametersRequest) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return Api.Zones.replaceZoneParameters(_objectSpread(_objectSpread({}, replaceZoneParametersRequest), {}, {
                xBffCsrf: this._xBffCsrf.toString()
              }));
            case 2:
              return _context8.abrupt("return", _context8.sent);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function replaceZoneParameters(_x9) {
        return _replaceZoneParameters.apply(this, arguments);
      }
      return replaceZoneParameters;
    }()
  }, {
    key: "deleteZone",
    value: function () {
      var _deleteZone = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(deleteZoneRequest) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return Api.Zones.deleteZone(_objectSpread(_objectSpread({}, deleteZoneRequest), {}, {
                xBffCsrf: this._xBffCsrf.toString()
              }));
            case 2:
              return _context9.abrupt("return", _context9.sent);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function deleteZone(_x10) {
        return _deleteZone.apply(this, arguments);
      }
      return deleteZone;
    }()
  }]);
}();